import * as type from '../../../actions/index.types'

const initialState = {
    ieLoading: false,
    ieData: null,

    bsLoading: false,
    bsData: null,

    tbLoading: false,
    tbData: null,

    glLoading: false,
    glData: null,

    miLoading: false,
    miData: null,

    meLoading: false,
    meData: null,
};

export function AccountReportsReducer(state = initialState, action) {
    switch (action.type) {
        // Income & Expenditure
        case type.GET_INCOME_EXPENDITURE_REPORT: return { ...state, ieLoading: true }
        case type.GET_INCOME_EXPENDITURE_REPORT_SUCCESS:
            return { ...state, ieLoading: false, ieData: action.payload?.data || null }
        case type.GET_INCOME_EXPENDITURE_REPORT_FAILURE:
            return { ...state, ieLoading: false }

        // Balance Sheet
        case type.GET_BALANCE_SHEET_REPORT: return { ...state, bsLoading: true }
        case type.GET_BALANCE_SHEET_REPORT_SUCCESS:
            return { ...state, bsLoading: false, bsData: action.payload?.data || null }
        case type.GET_BALANCE_SHEET_REPORT_FAILURE:
            return { ...state, bsLoading: false }

        // Trial Balance
        case type.GET_TRIAL_BALANCE_REPORT: return { ...state, tbLoading: true }
        case type.GET_TRIAL_BALANCE_REPORT_SUCCESS:
            return { ...state, tbLoading: false, tbData: action.payload?.data || null }
        case type.GET_TRIAL_BALANCE_REPORT_FAILURE:
            return { ...state, tbLoading: false }

        // Group Ledger
        case type.GET_GROUP_LEDGER_REPORT: return { ...state, glLoading: true }
        case type.GET_GROUP_LEDGER_REPORT_SUCCESS:
            return { ...state, glLoading: false, glData: action.payload?.data || null }
        case type.GET_GROUP_LEDGER_REPORT_FAILURE:
            return { ...state, glLoading: false }

        // Monthly Income
        case type.GET_MONTHLY_INCOME_REPORT: return { ...state, miLoading: true }
        case type.GET_MONTHLY_INCOME_REPORT_SUCCESS:
            return { ...state, miLoading: false, miData: action.payload?.data || null }
        case type.GET_MONTHLY_INCOME_REPORT_FAILURE:
            return { ...state, miLoading: false }

        // Monthly Expenditure
        case type.GET_MONTHLY_EXPENDITURE_REPORT: return { ...state, meLoading: true }
        case type.GET_MONTHLY_EXPENDITURE_REPORT_SUCCESS:
            return { ...state, meLoading: false, meData: action.payload?.data || null }
        case type.GET_MONTHLY_EXPENDITURE_REPORT_FAILURE:
            return { ...state, meLoading: false }

        case type.CLEAR_ACCOUNT_REPORTS_STATE:
            return { ...initialState }

        default:
            return state
    }
}
